import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

import { ViewAllBtn } from '../../../components/custom';

import useVisibleClips from '../../../hooks/useVisibleClips';

import { useProjectStore } from '../../../stores/project';

import { File } from '../../../types';
import { isEmpty } from '../../../utils';

import { ClipPreview, ClipPreviewController } from './clipPreview';
import ThumbnailBlock from './thumbnailBlock';

interface Props {
  groupId?: string | null;
  videos: File[];
  collapseRequest?: boolean;
  handleClick?: (video: File) => void;
  handleDelete?: (video: File) => void;
  focusedClipId?: string;
  isBig?: boolean;
  isSample?: boolean;
}

const ThumbnailsContainer: React.FC<Props> = (props) => {
  const {
    groupId,
    videos,
    collapseRequest,
    handleClick,
    handleDelete,
    focusedClipId,
    isBig,
    isSample,
  } = props;

  const [isCollapsed, setIsCollapsed] = useState(true);

  const previewRef = useRef<ClipPreviewController>(null);

  useEffect(() => {
    if (collapseRequest !== undefined) setIsCollapsed(collapseRequest);
  }, [collapseRequest]);

  const isPortrait =
    useProjectStore((state) => state.currentProject?.videoMode) === 'portrait';

  const { visibleClips, showViewAllBtn, containerRef } = useVisibleClips({
    clips: videos,
    isCollapsed,
    isPortrait,
    isBig,
  });

  if (isEmpty(videos)) return null;

  const containerClass = classNames(
    'w-full flex flex-wrap justify-start',
    isBig ? 'gap-6' : 'gap-4',
  );

  return (
    <React.Fragment>
      <ClipPreview ref={previewRef} />

      <div ref={containerRef} className={containerClass} id={groupId ?? ''}>
        {visibleClips.map((video) => (
          <ThumbnailBlock
            key={video.elementId}
            groupId={groupId}
            video={video}
            onClick={() => handleClick?.(video)}
            onDelete={
              handleDelete && !isSample ? () => handleDelete(video) : undefined
            }
            isBig={isBig}
            isSample={isSample}
            isCurrent={focusedClipId === video.elementId}
            previewRef={previewRef}
          />
        ))}

        {showViewAllBtn && (
          <ViewAllBtn
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            isPortrait={isPortrait}
            isBig={isBig}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default ThumbnailsContainer;
